module.exports = __webpack_public_path__ + "img/verified-list-interface-symbol_gris.b296703b.svg";